var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('mainHeader'),_vm._v(" "),(!_vm.isIndex)?_c('div',{staticClass:"container"},[_c('sideNav',{staticClass:"nav"}),_vm._v(" "),_c('router-view',{staticClass:"view"})],1):_c('router-view',{staticClass:"page"}),_vm._v(" "),(!_vm.isIndex)?_c('mainFooter'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19cb9f4d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./examples/App.vue
// module id = null
// module chunks = 